export default "__VITE_ASSET__Pakx_sNt__"